// these are values for the query params
// oxlint-disable-next-line eslint/no-redeclare
export const OpportunityStatusFilterValueKey = {
	Open: 'open',
	Closed: 'closed',
} as const;
export type OpportunityStatusFilterValueKey =
	(typeof OpportunityStatusFilterValueKey)[keyof typeof OpportunityStatusFilterValueKey];
export const allOpportunityStatusFilterValueKeys: OpportunityStatusFilterValueKey[] = Object.values(
	OpportunityStatusFilterValueKey,
);

// these are the values that will be mapped to the isClosed boolean in the GQL query under SalesforceFilters
export const OpportunityStatusFilterValue: Record<OpportunityStatusFilterValueKey, boolean> = {
	[OpportunityStatusFilterValueKey.Open]: false,
	[OpportunityStatusFilterValueKey.Closed]: true,
} as const;
